<template>
  <div class="filter-toolbar">
    <div class="controls">
      <div class="control">
        <label>QRA</label>
        <select class="form-select" v-model="props.filters.qra">
          <option value="">Todos</option>
          <option v-for="q in props.uniqueQras" :key="q" :value="q">{{ q }}</option>
        </select>
      </div>

      <div class="control">
        <label>Viatura</label>
        <select class="form-select" v-model="props.filters.viatura">
          <option value="">Todos</option>
          <option v-for="v in props.uniqueViaturas" :key="v" :value="v">{{ v }}</option>
        </select>
      </div>

      <div class="control">
        <label>Módulo</label>
        <select class="form-select" v-model="props.filters.modulo">
          <option value="">Todos</option>
          <option v-for="m in props.uniqueModulos" :key="m" :value="m">{{ m }}</option>
        </select>
      </div>

      <div class="control">
        <label>Perfil</label>
        <select class="form-select" v-model="props.filters.perfil">
          <option value="">Todos</option>
          <option v-for="p in props.uniquePerfis" :key="p" :value="p">{{ p }}</option>
        </select>
      </div>

      <div class="control">
        <label>Observação</label>
        <select class="form-select" v-model="props.filters.observacao">
          <option value="">Todos</option>
          <option v-for="obs in props.uniqueObservacoes" :key="obs" :value="obs">{{ obs }}</option>
        </select>
      </div>

      <div class="control valor-control">
        <label>Valor</label>
        <input class="form-control" type="text" placeholder="Valor" v-model="props.filters.valor" />
      </div>

      <div class="control toggle-control">
        <label class="toggle-label">Somente com retornos</label>
        <input type="checkbox" v-model="props.filters.hasReturns" />
      </div>
    </div>

    <div class="actions">
      <button v-if="hasActiveFilters" class="clear-btn" @click="clearFilters">Limpar filtros</button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  filters: Object,
  uniqueQras: Array,
  uniqueViaturas: Array,
  uniqueModulos: Array,
  uniquePerfis: Array,
  uniqueObservacoes: Array,
  clearFilters: Function,
});

// APAGADO: const { filters, uniqueQras... } = props; <- Isso quebrava a reatividade!

const hasActiveFilters = computed(() => {
  if (!props.filters) return false;

  return Object.entries(props.filters).some(([key, value]) => {
    if (key === 'hasReturns') return Boolean(value);
    return String(value).trim() !== '';
  });
});

function clearFilters() {
  if (props.clearFilters) props.clearFilters();
}
</script>
<style scoped>
.filter-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 0.75rem 1rem;
  gap: 1rem;
}
.filter-toolbar .controls {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
}
.filter-toolbar .control { display:flex; flex-direction:column; min-width:120px; }
.filter-toolbar .valor-control { min-width:108px; }
.filter-toolbar .toggle-control { display:flex; align-items:center; gap:0.5rem; }
.filter-toolbar .actions { display:flex; align-items:center; gap:1rem; }
.clear-btn { background:transparent; border:none; color:#EF4444; cursor:pointer; font-weight:700; }
</style>
